import React from 'react';
import { navigate } from 'gatsby';
import Error from '../../General/Error';
import NoInvoiceIcon from '../../../images/errores/no-documentos.svg';

const Empty = () => (
  <Error
    type="No hay boletas"
    text="Por el momento no se ha generado tu historial de boletas"
    button={{
      text: 'volver al inicio',
      click: () => {
        navigate('/home');
      },
      color: 'bubbleGum',
      outline: false,
      transparent: false,
    }}
    icon={NoInvoiceIcon}
  />
);

export default Empty;
